<template>
  <div :class="!ishtmlContent || description.tooltip ? 'description-inline' : 'description-inline-block'" v-if="isDescription || hasSlot" :id="id">
    <template v-if="description.tooltip">
      <w-tooltip v-if="ishtmlContent">
        <template v-if="hasSlot">
          <slot />
        </template>

        <span v-else v-html="getDescription" />
      </w-tooltip>

      <w-tooltip v-else :tooltip="getDescription" />
    </template>

    <template v-else>
      <span class="description-content" v-if="ishtmlContent">
        <slot v-if="hasSlot" />

        <span v-else v-html="getDescription" />
      </span>

      <span class="description-content" v-else>
        <br v-if="description.newLine === null ? !description.tooltip : description.newLine" />
        {{ getDescription }}
      </span>
    </template>
  </div>
</template>

<script>
import titleMixin from '../mixins/titleMixin';

export default {
  name: 'w-description',
  mixins: [titleMixin],
  props: {
    model: {
      type: Object,
      required: false
    },
    id: {
      type: [String, Boolean],
      default: false
    }
  },
  computed: {
    hasSlot() {
      return !!this.$slots.default;
    },
    ishtmlContent() {
      return this.description.htmlContent || this.hasSlot;
    }
  }
};
</script>

<style>
.description-block {
  display: block;
}
.description-inline {
  display: inline;
}
.description-content {
  color: gray;
}
</style>
